import { vt2022httpapi } from './vt2022HTTPAPI.js';

const apiBaseUri = process.env.REACT_APP_API_BASE_URL;

export const vt2022api = () => vt2022httpapi(apiBaseUri);
